import { PlaceholderData } from '../../Types/containerV2';
import ModuleRenderer from './ModuleRenderer';
import './PlaceholderRenderer.scss';

type PlaceholderRendererProps = {
	placeholder: PlaceholderData;
};

const PlaceholderRenderer = ({ placeholder }: PlaceholderRendererProps) => {
	return (
		<div className='biz-placeholder' data-placeholder-name={placeholder.name} data-placeholder-id={placeholder.id}>
			{placeholder.modules.map((module) => (
				<ModuleRenderer key={module.guid} module={module} />
			))}
		</div>
	);
};

export default PlaceholderRenderer;
